import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const addUpsellPageToCheckoutExperience = {
  name: "addUpsellPageToCheckoutExperience" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    upsellPageId: zExt.objectId(),
  }),
  output: z.null(),
};
